import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import TabSection from '../components/TabSection';
import { SITE_URL } from '../config';
import Card from '../components/Card';
import DTC from '../assets/logos/DTC.svg';
import { useTranslation } from 'react-i18next';
import '../styling/sections.css';

function Forms({ activeSectionId, setActiveSectionId, setCurrentVideoUrl, setVideoSidebarOpen, setVideoLabels, setSelectedVideoIndex, setAllVideoUrls, registerSection, unregisterSection }) {

  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const isFR = i18n.language === 'fr';
  const dtcPath = isFR ? '/fr/credit-impot-pour-personnes-handicapees' : '/disability-tax-credit';
  const cdbPath = isFR ? '/fr/prestation-canadienne-pour-les-personnes-handicapees' : '/canada-disability-benefit';

  return (
    <>
      <Helmet>
        <title>{isFR ? 'Formulaires | deafinfo.ca/fr | ASC-CAD' : 'Forms | deafinfo.ca | CAD-ASC'}</title>
        <meta name="description" content="CAD-ASC provides resources and support for Canadians navigating disability benefits and tax credits." />
        <meta property="og:title" content={isFR ? 'Formulaires | deafinfo.ca/fr | ASC-CAD' : 'Forms | deafinfo.ca | CAD-ASC'} />
        <meta property="og:description" content="CAD-ASC provides resources and support for Canadians navigating disability benefits and tax credits." />
        <meta property="og:image" content={`${SITE_URL}/CAD-ASC-meta-image.png`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={isFR ? 'Formulaires | deafinfo.ca/fr | ASC-CAD' : 'Forms | deafinfo.ca | CAD-ASC'} />
        <meta name="twitter:description" content="CAD-ASC provides resources and support for Canadians navigating disability benefits and tax credits." />
        <meta name="twitter:image" content={`${SITE_URL}/CAD-ASC-meta-image.png`} />
      </Helmet>
    <div className="wrapper">
      <section className="mb-5">
         <section className="mb-5">
        <TabSection videoUrls={["/ASL/DISC ASL Forms.mp4", "/LSQ/Formulaires.mp4"]}
        videoLabels={["ASL", "LSQ"]}
        sectionId="sections.forms"
        activeSectionId={activeSectionId} 
        setActiveSectionId={setActiveSectionId} 
        setCurrentVideoUrl={setCurrentVideoUrl} 
        setVideoSidebarOpen={setVideoSidebarOpen} 
        setVideoLabels={setVideoLabels} 
        setSelectedVideoIndex={setSelectedVideoIndex} 
        setAllVideoUrls={setAllVideoUrls} 
        isDefault 
        registerSection={registerSection} 
        unregisterSection={unregisterSection}>
            <div className="flex col section-copy">
                <h1>{t('forms.page.forms-title')}</h1>
                <p style={{ paddingTop: '0.5rem' }}>{t('forms.page.forms-description')}</p>
            </div>
          </TabSection>
        </section>


        {/* FORMS SECTION */}
        <TabSection 
        videoUrls={["/ASL/DISC ASL DTC and CDB click to view.mp4", "/LSQ/Form page - DTC and CDB click to view.mp4"]}
        videoLabels={["ASL", "LSQ"]}
        sectionId="sections.the-forms"
        activeSectionId={activeSectionId} 
        setActiveSectionId={setActiveSectionId} 
        setCurrentVideoUrl={setCurrentVideoUrl} 
        setVideoSidebarOpen={setVideoSidebarOpen} 
        setVideoLabels={setVideoLabels} 
        setSelectedVideoIndex={setSelectedVideoIndex} 
        setAllVideoUrls={setAllVideoUrls} 
        registerSection={registerSection} 
        unregisterSection={unregisterSection}>
            <div className="flex row gap-3">
                <Card
                title={t('forms.card.form1-name')} 
                icon={<img src={DTC} alt="DTC Icon" />}
                cardType="3"
                onClick={() => navigate(dtcPath)}
                bodycopy={t('forms.card.form1-description')} 
                buttonType="primary"
                buttoncopy={t('forms.card.form1-button')}
                >
                </Card>

                <Card 
                title={t('forms.card.form2-name')} 
                icon={<img src={DTC} alt="DTC Icon" />}
                cardType="3"
                onClick={() => navigate(cdbPath)}
                bodycopy={t('forms.card.form2-description')} 
                buttonType="primary"
                buttoncopy={t('forms.card.form2-button')}
                >
                </Card>

          </div>
        </TabSection>
      </section>
    </div>
    </>
  );
}

export default Forms;
